export { SmartMetricsBadge } from './SmartMetricsBadge'
